export const budgetsTranslations: Record<string, any> = {
  pt: {
    title: "Orçamento",
    subtitle: "Planeie as receitas e despesas para todo o ano",
    previous_year: "Ano anterior",
    next_year: "Ano seguinte",
    loading: "A carregar orçamento...",
    load_failed: "Não foi possível carregar o orçamento.",
    retry: "Tentar novamente",
    save_success: "Alterações guardadas",
    save_failed: "Falha ao guardar alterações.",
    line_added: "Linha de orçamento criada: {{name}}",
    line_add_failed: "Falha ao adicionar linha de orçamento.",
    line_deleted: "Linha de orçamento eliminada",
    line_delete_failed: "Falha ao eliminar linha de orçamento.",
    view_grid: "Visão mensal",
    view_list: "Lista",
    scale_reduce: "Reduzir para milhares (0.0k)",
    scale_full: "Mostrar valores completos (0.000)",
    add_line: "Adicionar linha de orçamento",
    save_changes: "Guardar alterações",
    edit: "Editar",
    info_title: "As categorias de orçamento são correspondidas com transações Open Banking",
    info_body: "Os dados reais de fluxo de caixa serão comparados automaticamente com estes valores orçamentados. Ative \"Com Orçamento\" no Fluxo de Caixa para ver a comparação.",
    section_revenue: "RECEITAS",
    section_expenses: "DESPESAS",
    section_summary: "RESUMO ANUAL",
    row_total_revenue: "TOTAL RECEITAS",
    row_total_expenses: "TOTAL DESPESAS",
    table_name: "Nome",
    table_net_cashflow: "Fluxo de Caixa Líquido",
    table_running_balance: "Saldo Acumulado",
    total_revenue: "Receita Total (Ano)",
    total_expenses: "Despesas Totais (Ano)",
    total_net_profit: "Lucro Líquido (Ano)",
    total_final_balance: "Saldo Final (Dez)",
    list_title: "Linhas de orçamento",
    list_header_name: "Nome",
    list_header_type: "Tipo",
    list_header_category: "Categoria",
    list_header_method: "Método",
    list_header_detail: "Detalhe",
    list_header_total: "Total anual",
    list_header_reminder: "Lembrete",
    list_header_notes: "Notas",
    list_empty: "Não existem linhas de orçamento.",
    line_type_revenue: "Receita",
    line_type_expense: "Despesa",
    fill_pattern_recurring: "Recorrente",
    fill_pattern_quarterly: "Trimestral",
    fill_pattern_one_time: "Pontual",
    fill_pattern_growth: "Crescimento",
    fill_pattern_custom: "Personalizado",
    fill_pattern_detail_recurring_amount: "{{amount}} / mês",
    fill_pattern_detail_recurring: "Recorrente",
    fill_pattern_detail_quarterly: "Trimestral",
    fill_pattern_detail_one_time: "Pontual",
    fill_pattern_detail_growth: "Crescimento",
    fill_pattern_detail_growth_rate: "Crescimento {{rate}}%",
    fill_pattern_detail_custom: "Valores personalizados",
    fill_pattern_detail_none: "—",
    dialog_title: "Adicionar linha de orçamento",
    dialog_description: "Crie uma nova linha de orçamento para o ano com opções inteligentes",
    dialog_edit_title: "Editar linha de orçamento",
    dialog_edit_description: "Atualize os detalhes da linha de orçamento.",
    form_name_label: "Nome",
    form_name_placeholder: "ex.: Subscrições MRR, Salários, AWS",
    form_type_label: "Tipo",
    form_type_revenue: "💰 Receita",
    form_type_expense: "💸 Despesa",
    form_category_label: "Categoria",
    form_category_hint: "(para corresponder com transações)",
    form_category_placeholder: "Selecionar categoria",
    form_fill_title: "Como preencher os 12 meses?",
    fill_recurring_label: "Mesmo valor todos os meses (Recorrente)",
    fill_apply_all: "Aplicar aos 12 meses",
    fill_quarterly_label: "Trimestral (a cada 3 meses)",
    fill_one_time_label: "Pontual (apenas um mês específico)",
    fill_growth_label: "Padrão de crescimento",
    fill_custom_label: "Valores diferentes por mês",
    input_amount_placeholder: "Valor",
    quarterly_start_placeholder: "Mês inicial",
    quarterly_start_jan: "Janeiro ({{months}})",
    quarterly_start_feb: "Fevereiro ({{months}})",
    quarterly_start_mar: "Março ({{months}})",
    one_time_month_placeholder: "Selecionar mês",
    input_starting_amount_placeholder: "Valor inicial (Jan)",
    input_growth_rate_placeholder: "Taxa de crescimento por mês",
    preview_label: "Pré-visualização",
    notes_label: "Notas",
    notes_optional: "(Opcional)",
    notes_placeholder: "Adicione notas adicionais...",
    associations_label: "Associações",
    associations_hint: "Contexto opcional para comparar orçamento vs. transações reais.",
    client_label: "Cliente",
    client_placeholder: "Selecionar cliente",
    project_label: "Projeto",
    project_placeholder: "Selecionar projeto",
    vendor_label: "Fornecedor",
    vendor_placeholder: "Selecionar fornecedor",
    people_label: "Pessoas",
    people_hint: "Atribuição analítica apenas. Isto não altera o movimento bancário.",
    people_split_toggle: "Dividir por pessoas",
    person_label: "Pessoa associada",
    person_placeholder: "Selecionar pessoa",
    alloc_amount_label: "Valor",
    alloc_note_label: "Nota",
    alloc_remove_row: "Remover alocação",
    alloc_add_person: "Adicionar pessoa",
    alloc_annual_total: "Total anual",
    alloc_allocated: "Alocado",
    alloc_remaining: "Restante",
    allocations_requires_amount: "Defina um valor antes de alocar.",
    allocations_fill_all: "Selecione uma pessoa e um valor em cada linha.",
    allocations_unique_people: "Cada pessoa só pode ser alocada uma vez.",
    allocations_total_mismatch: "O total alocado deve corresponder ao valor anual do orçamento.",
    allocations_hint: "As alocações são apenas analíticas e não alteram o fluxo de caixa.",
    reminder_label: "Lembrete",
    reminder_hint: "Opcional. Define o dia do mês para lembrar este compromisso.",
    reminder_day_label: "Dia do mês",
    reminder_day_suffix: "de cada mês",
    reminder_day_value: "Dia {{day}}",
    button_cancel: "Cancelar",
    button_create: "Criar linha de orçamento",
    button_update: "Guardar alterações",
    edit_line: "Editar",
    list_header_actions: "Ações",
    category_subscriptions: "Subscrições",
    category_setup_fees: "Taxas de configuração",
    category_consulting: "Consultoria",
    category_project_revenue: "Receita de projetos",
    category_product_sales: "Vendas de produtos",
    category_other_revenue: "Outras receitas",
    category_salaries: "Salários",
    category_software_tools: "Software e ferramentas",
    category_marketing: "Marketing",
    category_infrastructure: "Infraestrutura",
    category_office_utilities: "Escritório e utilidades",
    category_professional_services: "Serviços profissionais",
    category_travel: "Viagens",
    category_insurance: "Seguros",
    category_taxes: "Impostos",
    category_other_expenses: "Outras despesas",
  },
  en: {
    title: "Budget",
    subtitle: "Plan your revenue and expenses for the entire year",
    previous_year: "Previous year",
    next_year: "Next year",
    loading: "Loading budget...",
    load_failed: "Unable to load budget.",
    retry: "Retry",
    save_success: "Changes saved",
    save_failed: "Failed to save changes.",
    line_added: "Budget line added: {{name}}",
    line_add_failed: "Failed to add budget line.",
    line_deleted: "Budget line deleted",
    line_delete_failed: "Failed to delete budget line.",
    view_grid: "Monthly view",
    view_list: "List",
    scale_reduce: "Reduce to thousands (0.0k)",
    scale_full: "Show full values (0.000)",
    add_line: "Add budget line",
    save_changes: "Save changes",
    edit: "Edit",
    info_title: "Budget categories are matched with Open Banking transactions",
    info_body: "Your actual cashflow data will be automatically compared with these budget values. Enable \"With Budget\" in Cashflow view to see the comparison.",
    section_revenue: "INCOME",
    section_expenses: "EXPENSES",
    section_summary: "ANNUAL SUMMARY",
    row_total_revenue: "TOTAL INCOME",
    row_total_expenses: "TOTAL EXPENSES",
    table_name: "Name",
    table_net_cashflow: "Net cashflow",
    table_running_balance: "Running balance",
    total_revenue: "Total income (Year)",
    total_expenses: "Total expenses (Year)",
    total_net_profit: "Net profit (Year)",
    total_final_balance: "Final balance (Dec)",
    list_title: "Budget lines",
    list_header_name: "Name",
    list_header_type: "Type",
    list_header_category: "Category",
    list_header_method: "Method",
    list_header_detail: "Detail",
    list_header_total: "Annual total",
    list_header_reminder: "Reminder",
    list_header_notes: "Notes",
    list_empty: "No budget lines.",
    line_type_revenue: "Income",
    line_type_expense: "Expense",
    fill_pattern_recurring: "Recurring",
    fill_pattern_quarterly: "Quarterly",
    fill_pattern_one_time: "One-time",
    fill_pattern_growth: "Growth",
    fill_pattern_custom: "Custom",
    fill_pattern_detail_recurring_amount: "{{amount}} / month",
    fill_pattern_detail_recurring: "Recurring",
    fill_pattern_detail_quarterly: "Quarterly",
    fill_pattern_detail_one_time: "One-time",
    fill_pattern_detail_growth: "Growth",
    fill_pattern_detail_growth_rate: "Growth {{rate}}%",
    fill_pattern_detail_custom: "Custom values",
    fill_pattern_detail_none: "—",
    dialog_title: "Add budget line",
    dialog_description: "Create a new budget line for the year with smart filling options",
    dialog_edit_title: "Edit budget line",
    dialog_edit_description: "Update the details for this budget line.",
    form_name_label: "Name",
    form_name_placeholder: "e.g., Subscriptions MRR, Salaries, AWS",
    form_type_label: "Type",
    form_type_revenue: "💰 Income",
    form_type_expense: "💸 Expense",
    form_category_label: "Category",
    form_category_hint: "(for matching with transactions)",
    form_category_placeholder: "Select a category",
    form_fill_title: "How to fill the 12 months?",
    fill_recurring_label: "Same value every month (Recurring)",
    fill_apply_all: "Apply to all 12 months",
    fill_quarterly_label: "Quarterly (every 3 months)",
    fill_one_time_label: "One-time (specific month only)",
    fill_growth_label: "Growth pattern",
    fill_custom_label: "Different values each month",
    input_amount_placeholder: "Amount",
    quarterly_start_placeholder: "Starting month",
    quarterly_start_jan: "January ({{months}})",
    quarterly_start_feb: "February ({{months}})",
    quarterly_start_mar: "March ({{months}})",
    one_time_month_placeholder: "Select month",
    input_starting_amount_placeholder: "Starting amount (Jan)",
    input_growth_rate_placeholder: "Growth rate per month",
    preview_label: "Preview",
    notes_label: "Notes",
    notes_optional: "(Optional)",
    notes_placeholder: "Add any additional notes...",
    associations_label: "Associations",
    associations_hint: "Optional context for comparing budget vs. real transactions.",
    client_label: "Client",
    client_placeholder: "Select client",
    project_label: "Project",
    project_placeholder: "Select project",
    vendor_label: "Vendor",
    vendor_placeholder: "Select vendor",
    people_label: "People",
    people_hint: "Analytic attribution only. This does not change the bank movement.",
    people_split_toggle: "Split by people",
    person_label: "Associated person",
    person_placeholder: "Select person",
    alloc_amount_label: "Amount",
    alloc_note_label: "Note",
    alloc_remove_row: "Remove allocation",
    alloc_add_person: "Add person",
    alloc_annual_total: "Annual total",
    alloc_allocated: "Allocated",
    alloc_remaining: "Remaining",
    allocations_requires_amount: "Define an amount before allocating.",
    allocations_fill_all: "Select a person and amount on every row.",
    allocations_unique_people: "Each person can only be allocated once.",
    allocations_total_mismatch: "Allocated total must match the annual budget amount.",
    allocations_hint: "Allocations are analytic only and do not change cashflow totals.",
    reminder_label: "Reminder",
    reminder_hint: "Optional. Set the day of the month for this commitment.",
    reminder_day_label: "Day of month",
    reminder_day_suffix: "each month",
    reminder_day_value: "Day {{day}}",
    button_cancel: "Cancel",
    button_create: "Create budget line",
    button_update: "Save changes",
    edit_line: "Edit",
    list_header_actions: "Actions",
    category_subscriptions: "Subscriptions",
    category_setup_fees: "Setup fees",
    category_consulting: "Consulting",
    category_project_revenue: "Project revenue",
    category_product_sales: "Product sales",
    category_other_revenue: "Other revenue",
    category_salaries: "Salaries",
    category_software_tools: "Software & tools",
    category_marketing: "Marketing",
    category_infrastructure: "Infrastructure",
    category_office_utilities: "Office & utilities",
    category_professional_services: "Professional services",
    category_travel: "Travel",
    category_insurance: "Insurance",
    category_taxes: "Taxes",
    category_other_expenses: "Other expenses",
  },
  es: {
    title: "Presupuesto",
    subtitle: "Planifica tus ingresos y gastos para todo el año",
    previous_year: "Año anterior",
    next_year: "Año siguiente",
    loading: "Cargando presupuesto...",
    load_failed: "No se pudo cargar el presupuesto.",
    retry: "Reintentar",
    save_success: "Cambios guardados",
    save_failed: "Error al guardar los cambios.",
    line_added: "Línea de presupuesto creada: {{name}}",
    line_add_failed: "Error al añadir la línea de presupuesto.",
    line_deleted: "Línea de presupuesto eliminada",
    line_delete_failed: "Error al eliminar la línea de presupuesto.",
    view_grid: "Vista mensual",
    view_list: "Lista",
    scale_reduce: "Reducir a miles (0.0k)",
    scale_full: "Mostrar valores completos (0.000)",
    add_line: "Añadir línea de presupuesto",
    save_changes: "Guardar cambios",
    edit: "Editar",
    info_title: "Las categorías del presupuesto se relacionan con transacciones de Open Banking",
    info_body: "Los datos reales de flujo de caja se compararán automáticamente con estos valores presupuestados. Activa \"Con Presupuesto\" en el Flujo de Caja para ver la comparación.",
    section_revenue: "INGRESOS",
    section_expenses: "GASTOS",
    section_summary: "RESUMEN ANUAL",
    row_total_revenue: "TOTAL INGRESOS",
    row_total_expenses: "TOTAL GASTOS",
    table_name: "Nombre",
    table_net_cashflow: "Flujo de caja neto",
    table_running_balance: "Saldo acumulado",
    total_revenue: "Ingresos totales (Año)",
    total_expenses: "Gastos totales (Año)",
    total_net_profit: "Beneficio neto (Año)",
    total_final_balance: "Saldo final (Dic)",
    list_title: "Líneas de presupuesto",
    list_header_name: "Nombre",
    list_header_type: "Tipo",
    list_header_category: "Categoría",
    list_header_method: "Método",
    list_header_detail: "Detalle",
    list_header_total: "Total anual",
    list_header_reminder: "Recordatorio",
    list_header_notes: "Notas",
    list_empty: "No existen líneas de presupuesto.",
    line_type_revenue: "Ingreso",
    line_type_expense: "Gasto",
    fill_pattern_recurring: "Recurrente",
    fill_pattern_quarterly: "Trimestral",
    fill_pattern_one_time: "Puntual",
    fill_pattern_growth: "Crecimiento",
    fill_pattern_custom: "Personalizado",
    fill_pattern_detail_recurring_amount: "{{amount}} / mes",
    fill_pattern_detail_recurring: "Recurrente",
    fill_pattern_detail_quarterly: "Trimestral",
    fill_pattern_detail_one_time: "Puntual",
    fill_pattern_detail_growth: "Crecimiento",
    fill_pattern_detail_growth_rate: "Crecimiento {{rate}}%",
    fill_pattern_detail_custom: "Valores personalizados",
    fill_pattern_detail_none: "—",
    dialog_title: "Añadir línea de presupuesto",
    dialog_description: "Crea una nueva línea de presupuesto para el año con opciones inteligentes",
    form_name_label: "Nombre",
    form_name_placeholder: "p. ej., Suscripciones MRR, Salarios, AWS",
    form_type_label: "Tipo",
    form_type_revenue: "💰 Ingreso",
    form_type_expense: "💸 Gasto",
    form_category_label: "Categoría",
    form_category_hint: "(para coincidir con transacciones)",
    form_category_placeholder: "Seleccionar categoría",
    form_fill_title: "¿Cómo rellenar los 12 meses?",
    fill_recurring_label: "Mismo valor cada mes (Recurrente)",
    fill_apply_all: "Aplicar a los 12 meses",
    fill_quarterly_label: "Trimestral (cada 3 meses)",
    fill_one_time_label: "Puntual (solo un mes específico)",
    fill_growth_label: "Patrón de crecimiento",
    fill_custom_label: "Valores diferentes cada mes",
    input_amount_placeholder: "Importe",
    quarterly_start_placeholder: "Mes inicial",
    quarterly_start_jan: "Enero ({{months}})",
    quarterly_start_feb: "Febrero ({{months}})",
    quarterly_start_mar: "Marzo ({{months}})",
    one_time_month_placeholder: "Seleccionar mes",
    input_starting_amount_placeholder: "Importe inicial (Ene)",
    input_growth_rate_placeholder: "Tasa de crecimiento mensual",
    preview_label: "Vista previa",
    notes_label: "Notas",
    notes_optional: "(Opcional)",
    notes_placeholder: "Añade notas adicionales...",
    associations_label: "Asociaciones",
    associations_hint: "Contexto opcional para comparar presupuesto vs. transacciones reales.",
    client_label: "Cliente",
    client_placeholder: "Seleccionar cliente",
    project_label: "Proyecto",
    project_placeholder: "Seleccionar proyecto",
    vendor_label: "Proveedor",
    vendor_placeholder: "Seleccionar proveedor",
    people_label: "Personas",
    people_hint: "Atribución analítica únicamente. No cambia el movimiento bancario.",
    people_split_toggle: "Dividir por personas",
    person_label: "Persona asociada",
    person_placeholder: "Seleccionar persona",
    alloc_amount_label: "Importe",
    alloc_note_label: "Nota",
    alloc_remove_row: "Eliminar asignación",
    alloc_add_person: "Añadir persona",
    alloc_annual_total: "Total anual",
    alloc_allocated: "Asignado",
    alloc_remaining: "Restante",
    allocations_requires_amount: "Define un importe antes de asignar.",
    allocations_fill_all: "Selecciona una persona y un importe en cada fila.",
    allocations_unique_people: "Cada persona solo puede asignarse una vez.",
    allocations_total_mismatch: "El total asignado debe coincidir con el importe anual del presupuesto.",
    allocations_hint: "Las asignaciones son solo analíticas y no modifican el flujo de caja.",
    reminder_label: "Recordatorio",
    reminder_hint: "Opcional. Define el día del mes para recordar este compromiso.",
    reminder_day_label: "Día del mes",
    reminder_day_suffix: "de cada mes",
    reminder_day_value: "Día {{day}}",
    button_cancel: "Cancelar",
    button_create: "Crear línea de presupuesto",
    category_subscriptions: "Suscripciones",
    category_setup_fees: "Tarifas de configuración",
    category_consulting: "Consultoría",
    category_project_revenue: "Ingresos de proyectos",
    category_product_sales: "Ventas de productos",
    category_other_revenue: "Otros ingresos",
    category_salaries: "Salarios",
    category_software_tools: "Software y herramientas",
    category_marketing: "Marketing",
    category_infrastructure: "Infraestructura",
    category_office_utilities: "Oficina y servicios",
    category_professional_services: "Servicios profesionales",
    category_travel: "Viajes",
    category_insurance: "Seguros",
    category_taxes: "Impuestos",
    category_other_expenses: "Otros gastos",
  },
  et: {
    title: "Eelarve",
    subtitle: "Planeeri oma tulud ja kulud kogu aastaks",
    previous_year: "Eelmine aasta",
    next_year: "Järgmine aasta",
    loading: "Eelarve laadimine...",
    load_failed: "Eelarvet ei õnnestunud laadida.",
    retry: "Proovi uuesti",
    save_success: "Muudatused salvestatud",
    save_failed: "Muudatuste salvestamine ebaõnnestus.",
    line_added: "Eelarverida loodud: {{name}}",
    line_add_failed: "Eelarverea lisamine ebaõnnestus.",
    line_deleted: "Eelarverida kustutatud",
    line_delete_failed: "Eelarverea kustutamine ebaõnnestus.",
    view_grid: "Kuine vaade",
    view_list: "Loend",
    scale_reduce: "Vähenda tuhandetesse (0.0k)",
    scale_full: "Kuva täisväärtused (0.000)",
    add_line: "Lisa eelarverida",
    save_changes: "Salvesta muudatused",
    edit: "Muuda",
    info_title: "Eelarvekategooriad seotakse Open Banking tehingutega",
    info_body: "Tegelik rahavoog võrreldakse automaatselt nende eelarveväärtustega. Võrdluse nägemiseks lülita Rahavoos sisse \"Eelarvega\".",
    section_revenue: "TULUD",
    section_expenses: "KULUD",
    section_summary: "AASTA KOKKUVÕTE",
    row_total_revenue: "KOGUTULU",
    row_total_expenses: "KOGUKULUD",
    table_name: "Nimi",
    table_net_cashflow: "Netorahavoog",
    table_running_balance: "Jooksev saldo",
    total_revenue: "Kogutulu (Aasta)",
    total_expenses: "Kogukulud (Aasta)",
    total_net_profit: "Puhaskasum (Aasta)",
    total_final_balance: "Lõppsaldo (Dets)",
    list_title: "Eelarveread",
    list_header_name: "Nimi",
    list_header_type: "Tüüp",
    list_header_category: "Kategooria",
    list_header_method: "Meetod",
    list_header_detail: "Detail",
    list_header_total: "Aasta kokku",
    list_header_reminder: "Meeldetuletus",
    list_header_notes: "Märkused",
    list_empty: "Eelarveridu ei ole.",
    line_type_revenue: "Tulu",
    line_type_expense: "Kulu",
    fill_pattern_recurring: "Korduv",
    fill_pattern_quarterly: "Kvartaalne",
    fill_pattern_one_time: "Ühekordne",
    fill_pattern_growth: "Kasv",
    fill_pattern_custom: "Kohandatud",
    fill_pattern_detail_recurring_amount: "{{amount}} / kuu",
    fill_pattern_detail_recurring: "Korduv",
    fill_pattern_detail_quarterly: "Kvartaalne",
    fill_pattern_detail_one_time: "Ühekordne",
    fill_pattern_detail_growth: "Kasv",
    fill_pattern_detail_growth_rate: "Kasv {{rate}}%",
    fill_pattern_detail_custom: "Kohandatud väärtused",
    fill_pattern_detail_none: "—",
    dialog_title: "Lisa eelarverida",
    dialog_description: "Loo aasta jaoks uus eelarverida nutikate täitmisvalikutega",
    form_name_label: "Nimi",
    form_name_placeholder: "nt Tellimused MRR, Palgad, AWS",
    form_type_label: "Tüüp",
    form_type_revenue: "💰 Tulu",
    form_type_expense: "💸 Kulu",
    form_category_label: "Kategooria",
    form_category_hint: "(tehingutega sobitamiseks)",
    form_category_placeholder: "Vali kategooria",
    form_fill_title: "Kuidas täita 12 kuud?",
    fill_recurring_label: "Sama väärtus iga kuu (Korduv)",
    fill_apply_all: "Rakenda kõigile 12 kuule",
    fill_quarterly_label: "Kvartaalne (iga 3 kuu järel)",
    fill_one_time_label: "Ühekordne (ainult üks kuu)",
    fill_growth_label: "Kasvumuster",
    fill_custom_label: "Erinevad väärtused igas kuus",
    input_amount_placeholder: "Summa",
    quarterly_start_placeholder: "Alguskuu",
    quarterly_start_jan: "Jaanuar ({{months}})",
    quarterly_start_feb: "Veebruar ({{months}})",
    quarterly_start_mar: "Märts ({{months}})",
    one_time_month_placeholder: "Vali kuu",
    input_starting_amount_placeholder: "Algsumma (Jaan)",
    input_growth_rate_placeholder: "Kasvumäär kuus",
    preview_label: "Eelvaade",
    notes_label: "Märkused",
    notes_optional: "(Valikuline)",
    notes_placeholder: "Lisa lisamärkused...",
    associations_label: "Seosed",
    associations_hint: "Valikuline kontekst eelarve ja tegelike tehingute võrdlemiseks.",
    client_label: "Klient",
    client_placeholder: "Vali klient",
    project_label: "Projekt",
    project_placeholder: "Vali projekt",
    vendor_label: "Tarnija",
    vendor_placeholder: "Vali tarnija",
    people_label: "Inimesed",
    people_hint: "Ainult analüütiline omistus. See ei muuda pangaliikumist.",
    people_split_toggle: "Jaga inimeste vahel",
    person_label: "Seotud isik",
    person_placeholder: "Vali isik",
    alloc_amount_label: "Summa",
    alloc_note_label: "Märkus",
    alloc_remove_row: "Eemalda jaotus",
    alloc_add_person: "Lisa isik",
    alloc_annual_total: "Aastane kogusumma",
    alloc_allocated: "Jaotatud",
    alloc_remaining: "Järele jäänud",
    allocations_requires_amount: "Määra summa enne jaotamist.",
    allocations_fill_all: "Vali igal real isik ja summa.",
    allocations_unique_people: "Iga isik saab olla jaotatud ainult üks kord.",
    allocations_total_mismatch: "Jaotatud kogusumma peab ühtima eelarve aasta summaga.",
    allocations_hint: "Jaotused on ainult analüütilised ega muuda rahavoogu.",
    reminder_label: "Meeldetuletus",
    reminder_hint: "Valikuline. Määra selle kohustuse jaoks kuu päev.",
    reminder_day_label: "Kuu päev",
    reminder_day_suffix: "iga kuu",
    reminder_day_value: "Päev {{day}}",
    button_cancel: "Tühista",
    button_create: "Loo eelarverida",
    category_subscriptions: "Tellimused",
    category_setup_fees: "Seadistustasud",
    category_consulting: "Konsultatsioon",
    category_project_revenue: "Projektitulu",
    category_product_sales: "Tootemüük",
    category_other_revenue: "Muu tulu",
    category_salaries: "Palgad",
    category_software_tools: "Tarkvara ja tööriistad",
    category_marketing: "Turundus",
    category_infrastructure: "Infrastruktuur",
    category_office_utilities: "Kontor ja kommunaalid",
    category_professional_services: "Professionaalsed teenused",
    category_travel: "Reisid",
    category_insurance: "Kindlustus",
    category_taxes: "Maksud",
    category_other_expenses: "Muud kulud",
  },
  de: {
    title: "Budget",
    subtitle: "Plane deine Einnahmen und Ausgaben für das ganze Jahr",
    previous_year: "Vorjahr",
    next_year: "Nächstes Jahr",
    loading: "Budget wird geladen...",
    load_failed: "Budget konnte nicht geladen werden.",
    retry: "Erneut versuchen",
    save_success: "Änderungen gespeichert",
    save_failed: "Änderungen konnten nicht gespeichert werden.",
    line_added: "Budgetzeile erstellt: {{name}}",
    line_add_failed: "Budgetzeile konnte nicht hinzugefügt werden.",
    line_deleted: "Budgetzeile gelöscht",
    line_delete_failed: "Budgetzeile konnte nicht gelöscht werden.",
    view_grid: "Monatsansicht",
    view_list: "Liste",
    scale_reduce: "Auf Tausender reduzieren (0.0k)",
    scale_full: "Volle Werte anzeigen (0.000)",
    add_line: "Budgetzeile hinzufügen",
    save_changes: "Änderungen speichern",
    edit: "Bearbeiten",
    info_title: "Budgetkategorien werden mit Open-Banking-Transaktionen abgeglichen",
    info_body: "Deine tatsächlichen Cashflow-Daten werden automatisch mit diesen Budgetwerten verglichen. Aktiviere \"Mit Budget\" in der Cashflow-Ansicht, um den Vergleich zu sehen.",
    section_revenue: "EINNAHMEN",
    section_expenses: "AUSGABEN",
    section_summary: "JAHRESÜBERSICHT",
    row_total_revenue: "GESAMTEINNAHMEN",
    row_total_expenses: "GESAMTAUSGABEN",
    table_name: "Name",
    table_net_cashflow: "Netto-Cashflow",
    table_running_balance: "Laufender Saldo",
    total_revenue: "Gesamteinnahmen (Jahr)",
    total_expenses: "Gesamtausgaben (Jahr)",
    total_net_profit: "Nettogewinn (Jahr)",
    total_final_balance: "Endsaldo (Dez)",
    list_title: "Budgetzeilen",
    list_header_name: "Name",
    list_header_type: "Typ",
    list_header_category: "Kategorie",
    list_header_method: "Methode",
    list_header_detail: "Detail",
    list_header_total: "Jahressumme",
    list_header_reminder: "Erinnerung",
    list_header_notes: "Notizen",
    list_empty: "Keine Budgetzeilen vorhanden.",
    line_type_revenue: "Einnahme",
    line_type_expense: "Ausgabe",
    fill_pattern_recurring: "Wiederkehrend",
    fill_pattern_quarterly: "Vierteljährlich",
    fill_pattern_one_time: "Einmalig",
    fill_pattern_growth: "Wachstum",
    fill_pattern_custom: "Benutzerdefiniert",
    fill_pattern_detail_recurring_amount: "{{amount}} / Monat",
    fill_pattern_detail_recurring: "Wiederkehrend",
    fill_pattern_detail_quarterly: "Vierteljährlich",
    fill_pattern_detail_one_time: "Einmalig",
    fill_pattern_detail_growth: "Wachstum",
    fill_pattern_detail_growth_rate: "Wachstum {{rate}}%",
    fill_pattern_detail_custom: "Individuelle Werte",
    fill_pattern_detail_none: "—",
    dialog_title: "Budgetzeile hinzufügen",
    dialog_description: "Erstelle eine neue Budgetzeile für das Jahr mit smarten Fülloptionen",
    form_name_label: "Name",
    form_name_placeholder: "z. B. Abos MRR, Gehälter, AWS",
    form_type_label: "Typ",
    form_type_revenue: "💰 Einnahme",
    form_type_expense: "💸 Ausgabe",
    form_category_label: "Kategorie",
    form_category_hint: "(zum Abgleich mit Transaktionen)",
    form_category_placeholder: "Kategorie auswählen",
    form_fill_title: "Wie sollen die 12 Monate gefüllt werden?",
    fill_recurring_label: "Gleicher Wert jeden Monat (Wiederkehrend)",
    fill_apply_all: "Für alle 12 Monate anwenden",
    fill_quarterly_label: "Vierteljährlich (alle 3 Monate)",
    fill_one_time_label: "Einmalig (nur ein bestimmter Monat)",
    fill_growth_label: "Wachstumsmuster",
    fill_custom_label: "Unterschiedliche Werte pro Monat",
    input_amount_placeholder: "Betrag",
    quarterly_start_placeholder: "Startmonat",
    quarterly_start_jan: "Januar ({{months}})",
    quarterly_start_feb: "Februar ({{months}})",
    quarterly_start_mar: "März ({{months}})",
    one_time_month_placeholder: "Monat auswählen",
    input_starting_amount_placeholder: "Startbetrag (Jan)",
    input_growth_rate_placeholder: "Wachstumsrate pro Monat",
    preview_label: "Vorschau",
    notes_label: "Notizen",
    notes_optional: "(Optional)",
    notes_placeholder: "Zusätzliche Notizen hinzufügen...",
    associations_label: "Zuordnungen",
    associations_hint: "Optionaler Kontext zum Vergleich von Budget und realen Transaktionen.",
    client_label: "Kunde",
    client_placeholder: "Kunde auswählen",
    project_label: "Projekt",
    project_placeholder: "Projekt auswählen",
    vendor_label: "Lieferant",
    vendor_placeholder: "Lieferant auswählen",
    people_label: "Personen",
    people_hint: "Nur analytische Zuordnung. Dies ändert die Bankbewegung nicht.",
    people_split_toggle: "Auf Personen aufteilen",
    person_label: "Zugeordnete Person",
    person_placeholder: "Person auswählen",
    alloc_amount_label: "Betrag",
    alloc_note_label: "Notiz",
    alloc_remove_row: "Zuordnung entfernen",
    alloc_add_person: "Person hinzufügen",
    alloc_annual_total: "Jahressumme",
    alloc_allocated: "Zugeteilt",
    alloc_remaining: "Verbleibend",
    allocations_requires_amount: "Betrag festlegen, bevor zugeordnet wird.",
    allocations_fill_all: "Wähle in jeder Zeile eine Person und einen Betrag.",
    allocations_unique_people: "Jede Person kann nur einmal zugeordnet werden.",
    allocations_total_mismatch: "Der zugeteilte Gesamtbetrag muss dem Jahresbudget entsprechen.",
    allocations_hint: "Zuordnungen sind nur analytisch und ändern den Cashflow nicht.",
    reminder_label: "Erinnerung",
    reminder_hint: "Optional. Lege den Tag des Monats für diese Verpflichtung fest.",
    reminder_day_label: "Tag des Monats",
    reminder_day_suffix: "jeden Monat",
    reminder_day_value: "Tag {{day}}",
    button_cancel: "Abbrechen",
    button_create: "Budgetzeile erstellen",
    category_subscriptions: "Abonnements",
    category_setup_fees: "Einrichtungsgebühren",
    category_consulting: "Beratung",
    category_project_revenue: "Projekterlöse",
    category_product_sales: "Produktverkäufe",
    category_other_revenue: "Sonstige Einnahmen",
    category_salaries: "Gehälter",
    category_software_tools: "Software & Tools",
    category_marketing: "Marketing",
    category_infrastructure: "Infrastruktur",
    category_office_utilities: "Büro & Nebenkosten",
    category_professional_services: "Professionelle Dienstleistungen",
    category_travel: "Reisen",
    category_insurance: "Versicherung",
    category_taxes: "Steuern",
    category_other_expenses: "Sonstige Ausgaben",
  },
  fr: {
    title: "Budget",
    subtitle: "Planifiez vos revenus et dépenses pour toute l'année",
    previous_year: "Année précédente",
    next_year: "Année suivante",
    loading: "Chargement du budget...",
    load_failed: "Impossible de charger le budget.",
    retry: "Réessayer",
    save_success: "Modifications enregistrées",
    save_failed: "Échec de l'enregistrement des modifications.",
    line_added: "Ligne de budget créée : {{name}}",
    line_add_failed: "Échec de l'ajout de la ligne de budget.",
    line_deleted: "Ligne de budget supprimée",
    line_delete_failed: "Échec de la suppression de la ligne de budget.",
    view_grid: "Vue mensuelle",
    view_list: "Liste",
    scale_reduce: "Réduire en milliers (0.0k)",
    scale_full: "Afficher les valeurs complètes (0.000)",
    add_line: "Ajouter une ligne de budget",
    save_changes: "Enregistrer les modifications",
    edit: "Modifier",
    info_title: "Les catégories budgétaires sont associées aux transactions Open Banking",
    info_body: "Vos données de cashflow réelles seront automatiquement comparées à ces valeurs budgétées. Activez \"Avec Budget\" dans la vue Cashflow pour voir la comparaison.",
    section_revenue: "REVENUS",
    section_expenses: "DÉPENSES",
    section_summary: "RÉSUMÉ ANNUEL",
    row_total_revenue: "TOTAL REVENUS",
    row_total_expenses: "TOTAL DÉPENSES",
    table_name: "Nom",
    table_net_cashflow: "Cashflow net",
    table_running_balance: "Solde courant",
    total_revenue: "Revenus totaux (Année)",
    total_expenses: "Dépenses totales (Année)",
    total_net_profit: "Bénéfice net (Année)",
    total_final_balance: "Solde final (Déc)",
    list_title: "Lignes de budget",
    list_header_name: "Nom",
    list_header_type: "Type",
    list_header_category: "Catégorie",
    list_header_method: "Méthode",
    list_header_detail: "Détail",
    list_header_total: "Total annuel",
    list_header_reminder: "Rappel",
    list_header_notes: "Notes",
    list_empty: "Aucune ligne de budget.",
    line_type_revenue: "Revenu",
    line_type_expense: "Dépense",
    fill_pattern_recurring: "Récurrent",
    fill_pattern_quarterly: "Trimestriel",
    fill_pattern_one_time: "Ponctuel",
    fill_pattern_growth: "Croissance",
    fill_pattern_custom: "Personnalisé",
    fill_pattern_detail_recurring_amount: "{{amount}} / mois",
    fill_pattern_detail_recurring: "Récurrent",
    fill_pattern_detail_quarterly: "Trimestriel",
    fill_pattern_detail_one_time: "Ponctuel",
    fill_pattern_detail_growth: "Croissance",
    fill_pattern_detail_growth_rate: "Croissance {{rate}}%",
    fill_pattern_detail_custom: "Valeurs personnalisées",
    fill_pattern_detail_none: "—",
    dialog_title: "Ajouter une ligne de budget",
    dialog_description: "Créez une nouvelle ligne de budget pour l'année avec des options intelligentes",
    form_name_label: "Nom",
    form_name_placeholder: "ex. Abonnements MRR, Salaires, AWS",
    form_type_label: "Type",
    form_type_revenue: "💰 Revenu",
    form_type_expense: "💸 Dépense",
    form_category_label: "Catégorie",
    form_category_hint: "(pour correspondre aux transactions)",
    form_category_placeholder: "Sélectionner une catégorie",
    form_fill_title: "Comment remplir les 12 mois ?",
    fill_recurring_label: "Même valeur chaque mois (Récurrent)",
    fill_apply_all: "Appliquer aux 12 mois",
    fill_quarterly_label: "Trimestriel (tous les 3 mois)",
    fill_one_time_label: "Ponctuel (mois spécifique uniquement)",
    fill_growth_label: "Modèle de croissance",
    fill_custom_label: "Valeurs différentes chaque mois",
    input_amount_placeholder: "Montant",
    quarterly_start_placeholder: "Mois de départ",
    quarterly_start_jan: "Janvier ({{months}})",
    quarterly_start_feb: "Février ({{months}})",
    quarterly_start_mar: "Mars ({{months}})",
    one_time_month_placeholder: "Sélectionner un mois",
    input_starting_amount_placeholder: "Montant initial (Jan)",
    input_growth_rate_placeholder: "Taux de croissance par mois",
    preview_label: "Aperçu",
    notes_label: "Notes",
    notes_optional: "(Optionnel)",
    notes_placeholder: "Ajoutez des notes supplémentaires...",
    associations_label: "Associations",
    associations_hint: "Contexte optionnel pour comparer le budget aux transactions réelles.",
    client_label: "Client",
    client_placeholder: "Sélectionner un client",
    project_label: "Projet",
    project_placeholder: "Sélectionner un projet",
    vendor_label: "Fournisseur",
    vendor_placeholder: "Sélectionner un fournisseur",
    people_label: "Personnes",
    people_hint: "Attribution analytique uniquement. Cela ne modifie pas le mouvement bancaire.",
    people_split_toggle: "Répartir par personnes",
    person_label: "Personne associée",
    person_placeholder: "Sélectionner une personne",
    alloc_amount_label: "Montant",
    alloc_note_label: "Note",
    alloc_remove_row: "Supprimer l'allocation",
    alloc_add_person: "Ajouter une personne",
    alloc_annual_total: "Total annuel",
    alloc_allocated: "Alloué",
    alloc_remaining: "Restant",
    allocations_requires_amount: "Définissez un montant avant d'allouer.",
    allocations_fill_all: "Sélectionnez une personne et un montant sur chaque ligne.",
    allocations_unique_people: "Chaque personne ne peut être allouée qu'une seule fois.",
    allocations_total_mismatch: "Le total alloué doit correspondre au montant annuel du budget.",
    allocations_hint: "Les allocations sont uniquement analytiques et ne modifient pas le cashflow.",
    reminder_label: "Rappel",
    reminder_hint: "Optionnel. Définissez le jour du mois pour cet engagement.",
    reminder_day_label: "Jour du mois",
    reminder_day_suffix: "chaque mois",
    reminder_day_value: "Jour {{day}}",
    button_cancel: "Annuler",
    button_create: "Créer une ligne de budget",
    category_subscriptions: "Abonnements",
    category_setup_fees: "Frais de mise en place",
    category_consulting: "Conseil",
    category_project_revenue: "Revenus de projet",
    category_product_sales: "Ventes de produits",
    category_other_revenue: "Autres revenus",
    category_salaries: "Salaires",
    category_software_tools: "Logiciels & outils",
    category_marketing: "Marketing",
    category_infrastructure: "Infrastructure",
    category_office_utilities: "Bureau & charges",
    category_professional_services: "Services professionnels",
    category_travel: "Voyages",
    category_insurance: "Assurance",
    category_taxes: "Taxes",
    category_other_expenses: "Autres dépenses",
  },
  it: {
    title: "Budget",
    subtitle: "Pianifica entrate e spese per l'intero anno",
    previous_year: "Anno precedente",
    next_year: "Anno successivo",
    loading: "Caricamento budget...",
    load_failed: "Impossibile caricare il budget.",
    retry: "Riprova",
    save_success: "Modifiche salvate",
    save_failed: "Impossibile salvare le modifiche.",
    line_added: "Riga di budget creata: {{name}}",
    line_add_failed: "Impossibile aggiungere la riga di budget.",
    line_deleted: "Riga di budget eliminata",
    line_delete_failed: "Impossibile eliminare la riga di budget.",
    view_grid: "Vista mensile",
    view_list: "Elenco",
    scale_reduce: "Riduci in migliaia (0.0k)",
    scale_full: "Mostra valori completi (0.000)",
    add_line: "Aggiungi riga di budget",
    save_changes: "Salva modifiche",
    edit: "Modifica",
    info_title: "Le categorie di budget sono abbinate alle transazioni Open Banking",
    info_body: "I dati reali del cashflow saranno confrontati automaticamente con questi valori di budget. Attiva \"Con Budget\" nella vista Cashflow per vedere il confronto.",
    section_revenue: "ENTRATE",
    section_expenses: "SPESE",
    section_summary: "RIEPILOGO ANNUALE",
    row_total_revenue: "TOTALE ENTRATE",
    row_total_expenses: "TOTALE SPESE",
    table_name: "Nome",
    table_net_cashflow: "Cashflow netto",
    table_running_balance: "Saldo progressivo",
    total_revenue: "Entrate totali (Anno)",
    total_expenses: "Spese totali (Anno)",
    total_net_profit: "Utile netto (Anno)",
    total_final_balance: "Saldo finale (Dic)",
    list_title: "Righe di budget",
    list_header_name: "Nome",
    list_header_type: "Tipo",
    list_header_category: "Categoria",
    list_header_method: "Metodo",
    list_header_detail: "Dettaglio",
    list_header_total: "Totale annuale",
    list_header_reminder: "Promemoria",
    list_header_notes: "Note",
    list_empty: "Nessuna riga di budget.",
    line_type_revenue: "Entrata",
    line_type_expense: "Spesa",
    fill_pattern_recurring: "Ricorrente",
    fill_pattern_quarterly: "Trimestrale",
    fill_pattern_one_time: "Una tantum",
    fill_pattern_growth: "Crescita",
    fill_pattern_custom: "Personalizzato",
    fill_pattern_detail_recurring_amount: "{{amount}} / mese",
    fill_pattern_detail_recurring: "Ricorrente",
    fill_pattern_detail_quarterly: "Trimestrale",
    fill_pattern_detail_one_time: "Una tantum",
    fill_pattern_detail_growth: "Crescita",
    fill_pattern_detail_growth_rate: "Crescita {{rate}}%",
    fill_pattern_detail_custom: "Valori personalizzati",
    fill_pattern_detail_none: "—",
    dialog_title: "Aggiungi riga di budget",
    dialog_description: "Crea una nuova riga di budget per l'anno con opzioni intelligenti",
    form_name_label: "Nome",
    form_name_placeholder: "es. Abbonamenti MRR, Stipendi, AWS",
    form_type_label: "Tipo",
    form_type_revenue: "💰 Entrata",
    form_type_expense: "💸 Spesa",
    form_category_label: "Categoria",
    form_category_hint: "(per abbinare le transazioni)",
    form_category_placeholder: "Seleziona una categoria",
    form_fill_title: "Come compilare i 12 mesi?",
    fill_recurring_label: "Stesso valore ogni mese (Ricorrente)",
    fill_apply_all: "Applica a tutti i 12 mesi",
    fill_quarterly_label: "Trimestrale (ogni 3 mesi)",
    fill_one_time_label: "Una tantum (solo un mese specifico)",
    fill_growth_label: "Schema di crescita",
    fill_custom_label: "Valori diversi ogni mese",
    input_amount_placeholder: "Importo",
    quarterly_start_placeholder: "Mese iniziale",
    quarterly_start_jan: "Gennaio ({{months}})",
    quarterly_start_feb: "Febbraio ({{months}})",
    quarterly_start_mar: "Marzo ({{months}})",
    one_time_month_placeholder: "Seleziona mese",
    input_starting_amount_placeholder: "Importo iniziale (Gen)",
    input_growth_rate_placeholder: "Tasso di crescita mensile",
    preview_label: "Anteprima",
    notes_label: "Note",
    notes_optional: "(Opzionale)",
    notes_placeholder: "Aggiungi note aggiuntive...",
    associations_label: "Associazioni",
    associations_hint: "Contesto opzionale per confrontare budget e transazioni reali.",
    client_label: "Cliente",
    client_placeholder: "Seleziona cliente",
    project_label: "Progetto",
    project_placeholder: "Seleziona progetto",
    vendor_label: "Fornitore",
    vendor_placeholder: "Seleziona fornitore",
    people_label: "Persone",
    people_hint: "Attribuzione solo analitica. Non modifica il movimento bancario.",
    people_split_toggle: "Dividi per persone",
    person_label: "Persona associata",
    person_placeholder: "Seleziona persona",
    alloc_amount_label: "Importo",
    alloc_note_label: "Nota",
    alloc_remove_row: "Rimuovi allocazione",
    alloc_add_person: "Aggiungi persona",
    alloc_annual_total: "Totale annuale",
    alloc_allocated: "Allocato",
    alloc_remaining: "Rimanente",
    allocations_requires_amount: "Definisci un importo prima di allocare.",
    allocations_fill_all: "Seleziona una persona e un importo in ogni riga.",
    allocations_unique_people: "Ogni persona può essere allocata solo una volta.",
    allocations_total_mismatch: "Il totale allocato deve corrispondere all'importo annuale del budget.",
    allocations_hint: "Le allocazioni sono solo analitiche e non modificano il cashflow.",
    reminder_label: "Promemoria",
    reminder_hint: "Opzionale. Imposta il giorno del mese per questo impegno.",
    reminder_day_label: "Giorno del mese",
    reminder_day_suffix: "ogni mese",
    reminder_day_value: "Giorno {{day}}",
    button_cancel: "Annulla",
    button_create: "Crea riga di budget",
    category_subscriptions: "Abbonamenti",
    category_setup_fees: "Costi di attivazione",
    category_consulting: "Consulenza",
    category_project_revenue: "Ricavi di progetto",
    category_product_sales: "Vendite di prodotti",
    category_other_revenue: "Altri ricavi",
    category_salaries: "Stipendi",
    category_software_tools: "Software e strumenti",
    category_marketing: "Marketing",
    category_infrastructure: "Infrastruttura",
    category_office_utilities: "Ufficio e utenze",
    category_professional_services: "Servizi professionali",
    category_travel: "Viaggi",
    category_insurance: "Assicurazione",
    category_taxes: "Tasse",
    category_other_expenses: "Altre spese",
  },
  nl: {
    title: "Budget",
    subtitle: "Plan je inkomsten en uitgaven voor het hele jaar",
    previous_year: "Vorig jaar",
    next_year: "Volgend jaar",
    loading: "Budget laden...",
    load_failed: "Budget kan niet worden geladen.",
    retry: "Opnieuw proberen",
    save_success: "Wijzigingen opgeslagen",
    save_failed: "Wijzigingen opslaan mislukt.",
    line_added: "Budgetregel aangemaakt: {{name}}",
    line_add_failed: "Budgetregel toevoegen mislukt.",
    line_deleted: "Budgetregel verwijderd",
    line_delete_failed: "Budgetregel verwijderen mislukt.",
    view_grid: "Maandweergave",
    view_list: "Lijst",
    scale_reduce: "Verklein naar duizenden (0.0k)",
    scale_full: "Volledige waarden tonen (0.000)",
    add_line: "Budgetregel toevoegen",
    save_changes: "Wijzigingen opslaan",
    edit: "Bewerken",
    info_title: "Budgetcategorieën worden gekoppeld aan Open Banking-transacties",
    info_body: "Je werkelijke cashflowgegevens worden automatisch vergeleken met deze budgetwaarden. Schakel \"Met Budget\" in de cashflowweergave in om de vergelijking te zien.",
    section_revenue: "INKOMSTEN",
    section_expenses: "UITGAVEN",
    section_summary: "JAAROVERZICHT",
    row_total_revenue: "TOTALE INKOMSTEN",
    row_total_expenses: "TOTALE UITGAVEN",
    table_name: "Naam",
    table_net_cashflow: "Netto cashflow",
    table_running_balance: "Lopend saldo",
    total_revenue: "Totale inkomsten (Jaar)",
    total_expenses: "Totale uitgaven (Jaar)",
    total_net_profit: "Netto winst (Jaar)",
    total_final_balance: "Eindsaldo (Dec)",
    list_title: "Budgetregels",
    list_header_name: "Naam",
    list_header_type: "Type",
    list_header_category: "Categorie",
    list_header_method: "Methode",
    list_header_detail: "Detail",
    list_header_total: "Totaal per jaar",
    list_header_reminder: "Herinnering",
    list_header_notes: "Notities",
    list_empty: "Geen budgetregels.",
    line_type_revenue: "Inkomst",
    line_type_expense: "Uitgave",
    fill_pattern_recurring: "Terugkerend",
    fill_pattern_quarterly: "Per kwartaal",
    fill_pattern_one_time: "Eenmalig",
    fill_pattern_growth: "Groei",
    fill_pattern_custom: "Aangepast",
    fill_pattern_detail_recurring_amount: "{{amount}} / maand",
    fill_pattern_detail_recurring: "Terugkerend",
    fill_pattern_detail_quarterly: "Per kwartaal",
    fill_pattern_detail_one_time: "Eenmalig",
    fill_pattern_detail_growth: "Groei",
    fill_pattern_detail_growth_rate: "Groei {{rate}}%",
    fill_pattern_detail_custom: "Aangepaste waarden",
    fill_pattern_detail_none: "—",
    dialog_title: "Budgetregel toevoegen",
    dialog_description: "Maak een nieuwe budgetregel voor het jaar met slimme invulopties",
    form_name_label: "Naam",
    form_name_placeholder: "bijv. Abonnementen MRR, Salarissen, AWS",
    form_type_label: "Type",
    form_type_revenue: "💰 Inkomst",
    form_type_expense: "💸 Uitgave",
    form_category_label: "Categorie",
    form_category_hint: "(voor matchen met transacties)",
    form_category_placeholder: "Selecteer een categorie",
    form_fill_title: "Hoe de 12 maanden invullen?",
    fill_recurring_label: "Zelfde waarde elke maand (Terugkerend)",
    fill_apply_all: "Toepassen op alle 12 maanden",
    fill_quarterly_label: "Per kwartaal (elke 3 maanden)",
    fill_one_time_label: "Eenmalig (alleen specifieke maand)",
    fill_growth_label: "Groeipatroon",
    fill_custom_label: "Verschillende waarden per maand",
    input_amount_placeholder: "Bedrag",
    quarterly_start_placeholder: "Startmaand",
    quarterly_start_jan: "Januari ({{months}})",
    quarterly_start_feb: "Februari ({{months}})",
    quarterly_start_mar: "Maart ({{months}})",
    one_time_month_placeholder: "Selecteer maand",
    input_starting_amount_placeholder: "Startbedrag (Jan)",
    input_growth_rate_placeholder: "Maandelijkse groeivoet",
    preview_label: "Voorbeeld",
    notes_label: "Notities",
    notes_optional: "(Optioneel)",
    notes_placeholder: "Voeg extra notities toe...",
    associations_label: "Associaties",
    associations_hint: "Optionele context om budget met echte transacties te vergelijken.",
    client_label: "Klant",
    client_placeholder: "Selecteer klant",
    project_label: "Project",
    project_placeholder: "Selecteer project",
    vendor_label: "Leverancier",
    vendor_placeholder: "Selecteer leverancier",
    people_label: "Personen",
    people_hint: "Alleen analytische toewijzing. Dit verandert de bankbeweging niet.",
    people_split_toggle: "Verdelen over personen",
    person_label: "Gekoppelde persoon",
    person_placeholder: "Selecteer persoon",
    alloc_amount_label: "Bedrag",
    alloc_note_label: "Notitie",
    alloc_remove_row: "Toewijzing verwijderen",
    alloc_add_person: "Persoon toevoegen",
    alloc_annual_total: "Jaarlijks totaal",
    alloc_allocated: "Toegewezen",
    alloc_remaining: "Resterend",
    allocations_requires_amount: "Geef een bedrag op voordat je toewijst.",
    allocations_fill_all: "Selecteer in elke rij een persoon en bedrag.",
    allocations_unique_people: "Elke persoon kan maar één keer worden toegewezen.",
    allocations_total_mismatch: "Het toegewezen totaal moet overeenkomen met het jaarlijkse budgetbedrag.",
    allocations_hint: "Toewijzingen zijn alleen analytisch en veranderen de cashflow niet.",
    reminder_label: "Herinnering",
    reminder_hint: "Optioneel. Stel de dag van de maand in voor deze verplichting.",
    reminder_day_label: "Dag van de maand",
    reminder_day_suffix: "elke maand",
    reminder_day_value: "Dag {{day}}",
    button_cancel: "Annuleren",
    button_create: "Budgetregel maken",
    category_subscriptions: "Abonnementen",
    category_setup_fees: "Instelkosten",
    category_consulting: "Consultatie",
    category_project_revenue: "Projectinkomsten",
    category_product_sales: "Productverkopen",
    category_other_revenue: "Andere inkomsten",
    category_salaries: "Salarissen",
    category_software_tools: "Software & tools",
    category_marketing: "Marketing",
    category_infrastructure: "Infrastructuur",
    category_office_utilities: "Kantoor & nutsvoorzieningen",
    category_professional_services: "Professionele diensten",
    category_travel: "Reizen",
    category_insurance: "Verzekering",
    category_taxes: "Belastingen",
    category_other_expenses: "Andere uitgaven",
  },
  sv: {
    title: "Budget",
    subtitle: "Planera dina intäkter och utgifter för hela året",
    previous_year: "Föregående år",
    next_year: "Nästa år",
    loading: "Laddar budget...",
    load_failed: "Kunde inte ladda budget.",
    retry: "Försök igen",
    save_success: "Ändringar sparade",
    save_failed: "Det gick inte att spara ändringar.",
    line_added: "Budgetrad skapad: {{name}}",
    line_add_failed: "Det gick inte att lägga till budgetrad.",
    line_deleted: "Budgetrad borttagen",
    line_delete_failed: "Det gick inte att ta bort budgetrad.",
    view_grid: "Månadsvis",
    view_list: "Lista",
    scale_reduce: "Minska till tusental (0.0k)",
    scale_full: "Visa fulla värden (0.000)",
    add_line: "Lägg till budgetrad",
    save_changes: "Spara ändringar",
    edit: "Redigera",
    info_title: "Budgetkategorier matchas med Open Banking-transaktioner",
    info_body: "Din faktiska kassaflödesdata jämförs automatiskt med dessa budgetvärden. Aktivera \"Med Budget\" i kassaflödesvyn för att se jämförelsen.",
    section_revenue: "INTÄKTER",
    section_expenses: "UTGIFTER",
    section_summary: "ÅRSÖVERSIKT",
    row_total_revenue: "TOTALA INTÄKTER",
    row_total_expenses: "TOTALA UTGIFTER",
    table_name: "Namn",
    table_net_cashflow: "Nettokassaflöde",
    table_running_balance: "Löpande saldo",
    total_revenue: "Totala intäkter (År)",
    total_expenses: "Totala utgifter (År)",
    total_net_profit: "Nettoresultat (År)",
    total_final_balance: "Slutsaldo (Dec)",
    list_title: "Budgetrader",
    list_header_name: "Namn",
    list_header_type: "Typ",
    list_header_category: "Kategori",
    list_header_method: "Metod",
    list_header_detail: "Detalj",
    list_header_total: "Årssumma",
    list_header_reminder: "Påminnelse",
    list_header_notes: "Anteckningar",
    list_empty: "Inga budgetrader.",
    line_type_revenue: "Intäkt",
    line_type_expense: "Utgift",
    fill_pattern_recurring: "Återkommande",
    fill_pattern_quarterly: "Kvartalsvis",
    fill_pattern_one_time: "Engångs",
    fill_pattern_growth: "Tillväxt",
    fill_pattern_custom: "Anpassad",
    fill_pattern_detail_recurring_amount: "{{amount}} / månad",
    fill_pattern_detail_recurring: "Återkommande",
    fill_pattern_detail_quarterly: "Kvartalsvis",
    fill_pattern_detail_one_time: "Engångs",
    fill_pattern_detail_growth: "Tillväxt",
    fill_pattern_detail_growth_rate: "Tillväxt {{rate}}%",
    fill_pattern_detail_custom: "Anpassade värden",
    fill_pattern_detail_none: "—",
    dialog_title: "Lägg till budgetrad",
    dialog_description: "Skapa en ny budgetrad för året med smarta ifyllnadsalternativ",
    form_name_label: "Namn",
    form_name_placeholder: "t.ex. Abonnemang MRR, Löner, AWS",
    form_type_label: "Typ",
    form_type_revenue: "💰 Intäkt",
    form_type_expense: "💸 Utgift",
    form_category_label: "Kategori",
    form_category_hint: "(för matchning med transaktioner)",
    form_category_placeholder: "Välj kategori",
    form_fill_title: "Hur ska de 12 månaderna fyllas?",
    fill_recurring_label: "Samma värde varje månad (Återkommande)",
    fill_apply_all: "Tillämpa på alla 12 månader",
    fill_quarterly_label: "Kvartalsvis (var 3:e månad)",
    fill_one_time_label: "Engångs (endast en specifik månad)",
    fill_growth_label: "Tillväxtmönster",
    fill_custom_label: "Olika värden varje månad",
    input_amount_placeholder: "Belopp",
    quarterly_start_placeholder: "Startmånad",
    quarterly_start_jan: "Januari ({{months}})",
    quarterly_start_feb: "Februari ({{months}})",
    quarterly_start_mar: "Mars ({{months}})",
    one_time_month_placeholder: "Välj månad",
    input_starting_amount_placeholder: "Startbelopp (Jan)",
    input_growth_rate_placeholder: "Tillväxt per månad",
    preview_label: "Förhandsvisning",
    notes_label: "Anteckningar",
    notes_optional: "(Valfritt)",
    notes_placeholder: "Lägg till extra anteckningar...",
    associations_label: "Kopplingar",
    associations_hint: "Valfritt sammanhang för att jämföra budget med faktiska transaktioner.",
    client_label: "Kund",
    client_placeholder: "Välj kund",
    project_label: "Projekt",
    project_placeholder: "Välj projekt",
    vendor_label: "Leverantör",
    vendor_placeholder: "Välj leverantör",
    people_label: "Personer",
    people_hint: "Endast analytisk attribution. Detta ändrar inte bankrörelsen.",
    people_split_toggle: "Fördela på personer",
    person_label: "Associerad person",
    person_placeholder: "Välj person",
    alloc_amount_label: "Belopp",
    alloc_note_label: "Anteckning",
    alloc_remove_row: "Ta bort fördelning",
    alloc_add_person: "Lägg till person",
    alloc_annual_total: "Årlig total",
    alloc_allocated: "Fördelat",
    alloc_remaining: "Återstående",
    allocations_requires_amount: "Ange ett belopp innan du fördelar.",
    allocations_fill_all: "Välj en person och ett belopp på varje rad.",
    allocations_unique_people: "Varje person kan endast fördelas en gång.",
    allocations_total_mismatch: "Det fördelade totalbeloppet måste matcha den årliga budgeten.",
    allocations_hint: "Fördelningar är endast analytiska och påverkar inte kassaflödet.",
    reminder_label: "Påminnelse",
    reminder_hint: "Valfritt. Ange dag i månaden för detta åtagande.",
    reminder_day_label: "Dag i månaden",
    reminder_day_suffix: "varje månad",
    reminder_day_value: "Dag {{day}}",
    button_cancel: "Avbryt",
    button_create: "Skapa budgetrad",
    category_subscriptions: "Abonnemang",
    category_setup_fees: "Startavgifter",
    category_consulting: "Konsulttjänster",
    category_project_revenue: "Projektintäkter",
    category_product_sales: "Produktförsäljning",
    category_other_revenue: "Övriga intäkter",
    category_salaries: "Löner",
    category_software_tools: "Programvara & verktyg",
    category_marketing: "Marknadsföring",
    category_infrastructure: "Infrastruktur",
    category_office_utilities: "Kontor & drift",
    category_professional_services: "Professionella tjänster",
    category_travel: "Resor",
    category_insurance: "Försäkring",
    category_taxes: "Skatter",
    category_other_expenses: "Övriga utgifter",
  },
  da: {
    title: "Budget",
    subtitle: "Planlæg dine indtægter og udgifter for hele året",
    previous_year: "Forrige år",
    next_year: "Næste år",
    loading: "Indlæser budget...",
    load_failed: "Kunne ikke indlæse budget.",
    retry: "Prøv igen",
    save_success: "Ændringer gemt",
    save_failed: "Kunne ikke gemme ændringer.",
    line_added: "Budgetlinje oprettet: {{name}}",
    line_add_failed: "Kunne ikke tilføje budgetlinje.",
    line_deleted: "Budgetlinje slettet",
    line_delete_failed: "Kunne ikke slette budgetlinje.",
    view_grid: "Månedlig visning",
    view_list: "Liste",
    scale_reduce: "Reducer til tusinder (0.0k)",
    scale_full: "Vis fulde værdier (0.000)",
    add_line: "Tilføj budgetlinje",
    save_changes: "Gem ændringer",
    edit: "Rediger",
    info_title: "Budgetkategorier matches med Open Banking-transaktioner",
    info_body: "Dine faktiske cashflow-data sammenlignes automatisk med disse budgetværdier. Aktiver \"Med Budget\" i cashflow-visningen for at se sammenligningen.",
    section_revenue: "INDTÆGTER",
    section_expenses: "UDGIFTER",
    section_summary: "ÅRSOVERSIGT",
    row_total_revenue: "TOTAL INDTÆGTER",
    row_total_expenses: "TOTAL UDGIFTER",
    table_name: "Navn",
    table_net_cashflow: "Netto cashflow",
    table_running_balance: "Løbende saldo",
    total_revenue: "Samlede indtægter (År)",
    total_expenses: "Samlede udgifter (År)",
    total_net_profit: "Nettoresultat (År)",
    total_final_balance: "Slutsaldo (Dec)",
    list_title: "Budgetlinjer",
    list_header_name: "Navn",
    list_header_type: "Type",
    list_header_category: "Kategori",
    list_header_method: "Metode",
    list_header_detail: "Detalje",
    list_header_total: "Årlig total",
    list_header_reminder: "Påmindelse",
    list_header_notes: "Noter",
    list_empty: "Ingen budgetlinjer.",
    line_type_revenue: "Indtægt",
    line_type_expense: "Udgift",
    fill_pattern_recurring: "Tilbagevendende",
    fill_pattern_quarterly: "Kvartalsvis",
    fill_pattern_one_time: "Engangs",
    fill_pattern_growth: "Vækst",
    fill_pattern_custom: "Tilpasset",
    fill_pattern_detail_recurring_amount: "{{amount}} / måned",
    fill_pattern_detail_recurring: "Tilbagevendende",
    fill_pattern_detail_quarterly: "Kvartalsvis",
    fill_pattern_detail_one_time: "Engangs",
    fill_pattern_detail_growth: "Vækst",
    fill_pattern_detail_growth_rate: "Vækst {{rate}}%",
    fill_pattern_detail_custom: "Tilpassede værdier",
    fill_pattern_detail_none: "—",
    dialog_title: "Tilføj budgetlinje",
    dialog_description: "Opret en ny budgetlinje for året med smarte udfyldningsmuligheder",
    form_name_label: "Navn",
    form_name_placeholder: "fx Abonnementer MRR, Lønninger, AWS",
    form_type_label: "Type",
    form_type_revenue: "💰 Indtægt",
    form_type_expense: "💸 Udgift",
    form_category_label: "Kategori",
    form_category_hint: "(til matchning med transaktioner)",
    form_category_placeholder: "Vælg kategori",
    form_fill_title: "Hvordan udfyldes de 12 måneder?",
    fill_recurring_label: "Samme værdi hver måned (Tilbagevendende)",
    fill_apply_all: "Anvend på alle 12 måneder",
    fill_quarterly_label: "Kvartalsvis (hver 3. måned)",
    fill_one_time_label: "Engangs (kun en bestemt måned)",
    fill_growth_label: "Vækstmønster",
    fill_custom_label: "Forskellige værdier hver måned",
    input_amount_placeholder: "Beløb",
    quarterly_start_placeholder: "Startmåned",
    quarterly_start_jan: "Januar ({{months}})",
    quarterly_start_feb: "Februar ({{months}})",
    quarterly_start_mar: "Marts ({{months}})",
    one_time_month_placeholder: "Vælg måned",
    input_starting_amount_placeholder: "Startbeløb (Jan)",
    input_growth_rate_placeholder: "Vækstrate pr. måned",
    preview_label: "Forhåndsvisning",
    notes_label: "Noter",
    notes_optional: "(Valgfrit)",
    notes_placeholder: "Tilføj ekstra noter...",
    associations_label: "Tilknytninger",
    associations_hint: "Valgfri kontekst til at sammenligne budget med faktiske transaktioner.",
    client_label: "Kunde",
    client_placeholder: "Vælg kunde",
    project_label: "Projekt",
    project_placeholder: "Vælg projekt",
    vendor_label: "Leverandør",
    vendor_placeholder: "Vælg leverandør",
    people_label: "Personer",
    people_hint: "Kun analytisk tildeling. Dette ændrer ikke bankbevægelsen.",
    people_split_toggle: "Fordel på personer",
    person_label: "Tilknyttet person",
    person_placeholder: "Vælg person",
    alloc_amount_label: "Beløb",
    alloc_note_label: "Note",
    alloc_remove_row: "Fjern fordeling",
    alloc_add_person: "Tilføj person",
    alloc_annual_total: "Årlig total",
    alloc_allocated: "Fordelt",
    alloc_remaining: "Resterende",
    allocations_requires_amount: "Angiv et beløb før fordeling.",
    allocations_fill_all: "Vælg en person og et beløb på hver række.",
    allocations_unique_people: "Hver person kan kun fordeles én gang.",
    allocations_total_mismatch: "Det fordelte totalbeløb skal matche det årlige budgetbeløb.",
    allocations_hint: "Fordelinger er kun analytiske og ændrer ikke cashflow.",
    reminder_label: "Påmindelse",
    reminder_hint: "Valgfrit. Angiv dagen i måneden for denne forpligtelse.",
    reminder_day_label: "Dag i måneden",
    reminder_day_suffix: "hver måned",
    reminder_day_value: "Dag {{day}}",
    button_cancel: "Annuller",
    button_create: "Opret budgetlinje",
    category_subscriptions: "Abonnementer",
    category_setup_fees: "Opsætningsgebyrer",
    category_consulting: "Konsulent",
    category_project_revenue: "Projektindtægter",
    category_product_sales: "Produktsalg",
    category_other_revenue: "Andre indtægter",
    category_salaries: "Lønninger",
    category_software_tools: "Software og værktøjer",
    category_marketing: "Marketing",
    category_infrastructure: "Infrastruktur",
    category_office_utilities: "Kontor & forsyning",
    category_professional_services: "Professionelle tjenester",
    category_travel: "Rejser",
    category_insurance: "Forsikring",
    category_taxes: "Skatter",
    category_other_expenses: "Andre udgifter",
  },
  fi: {
    title: "Budjetti",
    subtitle: "Suunnittele tulosi ja menosi koko vuodelle",
    previous_year: "Edellinen vuosi",
    next_year: "Seuraava vuosi",
    loading: "Ladataan budjettia...",
    load_failed: "Budjettia ei voitu ladata.",
    retry: "Yritä uudelleen",
    save_success: "Muutokset tallennettu",
    save_failed: "Muutosten tallennus epäonnistui.",
    line_added: "Budjettirivi luotu: {{name}}",
    line_add_failed: "Budjettirivin lisääminen epäonnistui.",
    line_deleted: "Budjettirivi poistettu",
    line_delete_failed: "Budjettirivin poisto epäonnistui.",
    view_grid: "Kuukausinäkymä",
    view_list: "Lista",
    scale_reduce: "Pienennä tuhansiin (0.0k)",
    scale_full: "Näytä täydet arvot (0.000)",
    add_line: "Lisää budjettirivi",
    save_changes: "Tallenna muutokset",
    edit: "Muokkaa",
    info_title: "Budjettiluokat liitetään Open Banking -tapahtumiin",
    info_body: "Todelliset kassavirrat verrataan automaattisesti näihin budjettiarvoihin. Ota \"Budjetilla\" käyttöön kassavirta-näkymässä nähdäksesi vertailun.",
    section_revenue: "TULOT",
    section_expenses: "KULUT",
    section_summary: "VUOSIKATSAUS",
    row_total_revenue: "KOKONAISTULOT",
    row_total_expenses: "KOKONAISKULUT",
    table_name: "Nimi",
    table_net_cashflow: "Nettokassavirta",
    table_running_balance: "Kertyvä saldo",
    total_revenue: "Kokonaistulot (Vuosi)",
    total_expenses: "Kokonaiskulut (Vuosi)",
    total_net_profit: "Nettotulos (Vuosi)",
    total_final_balance: "Loppusaldo (Joulu)",
    list_title: "Budjettirivit",
    list_header_name: "Nimi",
    list_header_type: "Tyyppi",
    list_header_category: "Kategoria",
    list_header_method: "Menetelmä",
    list_header_detail: "Yksityiskohta",
    list_header_total: "Vuosiyhteensä",
    list_header_reminder: "Muistutus",
    list_header_notes: "Muistiinpanot",
    list_empty: "Budjettirivejä ei ole.",
    line_type_revenue: "Tulo",
    line_type_expense: "Kulu",
    fill_pattern_recurring: "Toistuva",
    fill_pattern_quarterly: "Kvartaaleittain",
    fill_pattern_one_time: "Kertaluonteinen",
    fill_pattern_growth: "Kasvu",
    fill_pattern_custom: "Mukautettu",
    fill_pattern_detail_recurring_amount: "{{amount}} / kk",
    fill_pattern_detail_recurring: "Toistuva",
    fill_pattern_detail_quarterly: "Kvartaaleittain",
    fill_pattern_detail_one_time: "Kertaluonteinen",
    fill_pattern_detail_growth: "Kasvu",
    fill_pattern_detail_growth_rate: "Kasvu {{rate}}%",
    fill_pattern_detail_custom: "Mukautetut arvot",
    fill_pattern_detail_none: "—",
    dialog_title: "Lisää budjettirivi",
    dialog_description: "Luo uusi budjettirivi vuodelle älykkäillä täyttövaihtoehdoilla",
    form_name_label: "Nimi",
    form_name_placeholder: "esim. Tilaukset MRR, Palkat, AWS",
    form_type_label: "Tyyppi",
    form_type_revenue: "💰 Tulo",
    form_type_expense: "💸 Kulu",
    form_category_label: "Kategoria",
    form_category_hint: "(tapahtumien yhdistämistä varten)",
    form_category_placeholder: "Valitse kategoria",
    form_fill_title: "Miten täyttää 12 kuukautta?",
    fill_recurring_label: "Sama arvo joka kuukausi (Toistuva)",
    fill_apply_all: "Käytä kaikkiin 12 kuukauteen",
    fill_quarterly_label: "Kvartaaleittain (joka 3. kuukausi)",
    fill_one_time_label: "Kertaluonteinen (vain tietty kuukausi)",
    fill_growth_label: "Kasvumalli",
    fill_custom_label: "Eri arvot joka kuussa",
    input_amount_placeholder: "Summa",
    quarterly_start_placeholder: "Aloituskuukausi",
    quarterly_start_jan: "Tammikuu ({{months}})",
    quarterly_start_feb: "Helmikuu ({{months}})",
    quarterly_start_mar: "Maaliskuu ({{months}})",
    one_time_month_placeholder: "Valitse kuukausi",
    input_starting_amount_placeholder: "Alkusumma (Tammi)",
    input_growth_rate_placeholder: "Kasvuprosentti/kk",
    preview_label: "Esikatselu",
    notes_label: "Muistiinpanot",
    notes_optional: "(Valinnainen)",
    notes_placeholder: "Lisää muistiinpanoja...",
    associations_label: "Liitokset",
    associations_hint: "Valinnainen konteksti budjetin ja todellisten tapahtumien vertailuun.",
    client_label: "Asiakas",
    client_placeholder: "Valitse asiakas",
    project_label: "Projekti",
    project_placeholder: "Valitse projekti",
    vendor_label: "Toimittaja",
    vendor_placeholder: "Valitse toimittaja",
    people_label: "Henkilöt",
    people_hint: "Vain analyyttinen kohdistus. Tämä ei muuta pankkiliikettä.",
    people_split_toggle: "Jaa henkilöille",
    person_label: "Liitetty henkilö",
    person_placeholder: "Valitse henkilö",
    alloc_amount_label: "Summa",
    alloc_note_label: "Muistiinpano",
    alloc_remove_row: "Poista kohdistus",
    alloc_add_person: "Lisää henkilö",
    alloc_annual_total: "Vuosittainen yhteensä",
    alloc_allocated: "Kohdistettu",
    alloc_remaining: "Jäljellä",
    allocations_requires_amount: "Määritä summa ennen kohdistamista.",
    allocations_fill_all: "Valitse jokaiselle riville henkilö ja summa.",
    allocations_unique_people: "Jokainen henkilö voidaan kohdistaa vain kerran.",
    allocations_total_mismatch: "Kohdistetun kokonaismäärän on vastattava budjetin vuosisummaa.",
    allocations_hint: "Kohdistukset ovat vain analyyttisiä eivätkä muuta kassavirtaa.",
    reminder_label: "Muistutus",
    reminder_hint: "Valinnainen. Aseta tämän sitoumuksen kuukauden päivä.",
    reminder_day_label: "Kuukauden päivä",
    reminder_day_suffix: "joka kuukausi",
    reminder_day_value: "Päivä {{day}}",
    button_cancel: "Peruuta",
    button_create: "Luo budjettirivi",
    category_subscriptions: "Tilaukset",
    category_setup_fees: "Aloitusmaksut",
    category_consulting: "Konsultointi",
    category_project_revenue: "Projektitulot",
    category_product_sales: "Tuotemyynti",
    category_other_revenue: "Muut tulot",
    category_salaries: "Palkat",
    category_software_tools: "Ohjelmistot ja työkalut",
    category_marketing: "Markkinointi",
    category_infrastructure: "Infrastruktuuri",
    category_office_utilities: "Toimisto ja palvelut",
    category_professional_services: "Ammatilliset palvelut",
    category_travel: "Matkustus",
    category_insurance: "Vakuutus",
    category_taxes: "Verot",
    category_other_expenses: "Muut kulut",
  },
};
